module.exports = __webpack_public_path__ + "static/media/iconOnTarget.8191311a.svg";